const PhenoPopup = ({ pheno }: { pheno: types.Pheno }) => (
  <>
    <div className="-mt-7 text-5xl font-semibold flex justify-between items-end">
      <span>{pheno.temp_day}°</span>
      <img
        src={`/images/pheno/${pheno.pheno_day}.svg`}
        style={{ height: 87 }}
      />
    </div>
    <div className="flex gap-5 text-xl text-gray-400">
      <span>Ш: {pheno.temp_night}°</span>
      <span>C: {pheno.wind_day} M/C</span>
    </div>
    <div className="text-2xl text-center font-semibold">{pheno.city}</div>
  </>
);
export default PhenoPopup;
